// _services/sponsorsService.js
import api from '../../../api/axios';

export const sponsorsService = {
  /**
   * Obtener patrocinadores del template
   */
  getSponsors: async (slug) => {
    const response = await api.get(`/admin/template/${slug}`);
    return response.data.sponsors || [];
  },

  /**
   * Agregar patrocinadores
   */
  addSponsors: async (slug, files) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("images", files[i]);
    }

    const token = localStorage.getItem("token");
    const response = await api.put(`/admin/template/${slug}/sponsors`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  /**
   * Eliminar patrocinador
   */
  deleteSponsor: async (slug, sponsorUrl) => {
    const token = localStorage.getItem("token");
    const response = await api.delete(`/admin/template/${slug}/sponsors`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { sponsor: sponsorUrl }
    });
    return response.data;
  },

  /**
   * Validar archivos de imagen
   */
  validateFiles: (files) => {
    const validFiles = [];
    const invalidFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type.startsWith('image/') && file.size <= 5 * 1024 * 1024) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file);
      }
    }

    return {
      valid: validFiles,
      invalid: invalidFiles,
      hasInvalid: invalidFiles.length > 0,
      message: invalidFiles.length > 0 
        ? `${invalidFiles.length} archivo(s) no son imágenes válidas (máximo 5MB)`
        : null
    };
  },

  /**
   * Extraer ID de la URL del patrocinador
   */
  extractSponsorId: (sponsorUrl) => {
    if (sponsorUrl.includes('/')) {
      const urlParts = sponsorUrl.split('/');
      return urlParts[urlParts.length - 1];
    }
    return sponsorUrl;
  },

  /**
   * Crear array continuo para animación (duplicar hasta tener mínimo 50 elementos)
   */
  getContinuousSponsors: (sponsors) => {
    if (!sponsors || sponsors.length === 0) return [];
    
    const MIN_ELEMENTS = 50;
    const repeatCount = Math.ceil(MIN_ELEMENTS / sponsors.length);
    
    let result = [];
    for (let i = 0; i < repeatCount; i++) {
      result = [...result, ...sponsors];
    }
    return result;
  },

  /**
   * Sponsor por defecto (placeholder)
   */
  getDefaultSponsor: () => '/placeholder-image.png',
};